import { PaperBox } from "../../../../../components/Layout/PaperBox"
import { IMovimentosPorAno, IUltimaCompra } from "../../../../../types/api/cadastros/detalhar-publico";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import { DadoValorPrinter } from "../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { Box, Link } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import DialogDetalhe from "./DialogDetalhe";

export const CardUltimasCompras = ({
    data,
    ultima_compra
}: CardUltimasComprasProps) => {

    data.sort((a, b) => Number(a.ano) - Number(b.ano));

    const [openDetalhe, setOpenDetalhe] = useState<boolean>(false)

   

    return (
        <>
            <PaperBox title="Últimas compras">
                {
                    ultima_compra &&
                    <Box display={'flex'} gap={2} flexWrap={'wrap'} justifyContent={'space-between'}>
                        <DadoValorPrinter titulo="Data última compra" valor={`${moment(ultima_compra.data).format('DD/MM/YYYY')}`} />
                        <DadoValorPrinter titulo="Valor" valor={`${formatarValorMonetario(ultima_compra.valor)}`} alignTitle="right" alignValue="right" />
                        <DadoValorPrinter titulo="Loja" valor={`${ultima_compra.loja}`} />
                    </Box>
                }
                <Box display={'flex'} justifyContent={'flex-end'}>
                    <Link mt={1} onClick={() => setOpenDetalhe(true)} sx={{ cursor: 'pointer' }}>Ver detalhes</Link>
                </Box>
               
            </PaperBox>
            {
                openDetalhe &&
                <DialogDetalhe
                    {...{ data }}
                    open={openDetalhe}
                    handleClose={() => setOpenDetalhe(false)}
                />
            }
        </>
    )
}

interface CardUltimasComprasProps {
    data: IMovimentosPorAno[];
    ultima_compra: IUltimaCompra | null
}
